import { CheckCircle2 } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

interface BenefitSectionProps {
  title: string;
  benefits: string[];
}

export default function BenefitSection({ title, benefits }: BenefitSectionProps) {
  const { theme } = useTheme();

  return (
    <section className="rounded-lg border bg-white p-5 shadow-sm" style={{ borderColor: theme.border, backgroundColor: theme.surface }}>
      <h2 className="mb-4 text-lg font-bold" style={{ color: theme.text }}>
        {title}
      </h2>
      <div className="space-y-3">
        {benefits.map((benefit) => (
          <div key={benefit} className="flex gap-3">
            <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0" style={{ color: theme.primary }} />
            <p className="mb-0 text-sm leading-6" style={{ color: theme.textSecondary }}>
              {benefit}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
